var App = App || {};

App.SwipeTabs = (function ($) {
    "use strict";

    const defaultSpeed = 400;

    function init() {
        var swipeTabs = $(".swipe-tabs__swipe-bg");

        swipeTabs.each(function () {
            var $thisTabSet = $(this);
            //initial setup
            moveIndicatorTo($thisTabSet, $thisTabSet.find(".nav-link.active"));

            //move indicator when new tab becomes active
            $thisTabSet.find('[data-bs-toggle="tab"]').on('show.bs.tab', function (e) {
                moveIndicatorTo($thisTabSet, $(e.target), defaultSpeed)
            });

            // Update indicator on scroll and resize
            $thisTabSet.find('.swipe-tabs__swipe-scroll').on('scroll', function () {
                moveIndicatorTo($thisTabSet, $thisTabSet.find(".nav-link.active"));
            });
            $(window).on('resize', function () {
                moveIndicatorTo($thisTabSet, $thisTabSet.find(".nav-link.active"));
            });
        });
    }

    function moveIndicatorTo($thisTabSet, $navLink, speed = 0) {
        var $swipeContent = $thisTabSet.find(".swipe-tabs__swipe-content");
        var $swipeMask = $thisTabSet.find(".swipe-tabs__swipe-mask");
        var $activeIndicator = $thisTabSet.find(".swipe-scroll-indicator");

        var activeOuterWidth = $navLink.outerWidth();
        var activeOffset = $navLink.position().left + $swipeContent.position().left;

        //resize when needed
        if ($activeIndicator.outerWidth() != activeOuterWidth) {
            $activeIndicator.css("max-width", activeOuterWidth);
        }

        //when animating and new tab is outside bounds of display
        if (speed != 0 && (activeOffset + $navLink.outerWidth() > $swipeMask.width() || activeOffset < 0)) {
            if (!$thisTabSet.hasClass("standby")) { //trigger only once per move
                $thisTabSet.addClass("standby");

                //move to new tab position once swipe tab scroll completes
                setTimeout(function () {
                    activeOffset = $navLink.position().left + $swipeContent.position().left;

                    checkAndReposition($activeIndicator, activeOffset, speed);

                    $thisTabSet.removeClass("standby"); //remove delay indicator to resume normal positioning
                }, 500);
            }
        }
        //reposition so long as above animation delay is not already in progress
        else if (!$thisTabSet.hasClass("standby"))
        {
            checkAndReposition($activeIndicator, activeOffset, speed);
        }
    }

    //move indicator to active tab if not alrady there.
    //optionally: animate for a duration of ms
    function checkAndReposition($scrollIndicator, activeOffset, speed = 0) {
        if ($scrollIndicator.attr("data-offset") != activeOffset) {

            $scrollIndicator.attr("data-offset", activeOffset);

            $scrollIndicator.animate(
                {
                    translateX: activeOffset,
                },
                {
                    duration: speed,
                    step: function (stepOffset) {
                        $(this).css("transform", `translateX(${stepOffset}px)`);
                    },
                }
            );
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.SwipeTabs.init();
});